import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import HelpCards from '../components/HelpCards';
import ApplianceBrands from '../components/ApplianceBrands';
import Pricing from '../components/Pricing';
import Promises from '../components/Promises';
import QuoteLookup from '../components/QuoteLookup';
import BrandStrip from '../components/BrandStrip';
import EngineersSection from '../components/EngineersSection';
import RepairCare from '../components/RepairCare';
import FAQSection from '../components/FAQSection';
import BlogSection from '../components/BlogSection';
import Footer from '../components/Footer';

const Section = ({ id, children }) => <section id={id} className="scroll-mt-24">{children}</section>;

const Home = () => {
  return (
    <div className="bg-[#FFF6EB] text-[#1F0068] min-h-screen">
      <Header />
      <main>
        <Section id="top"><Hero /></Section>
        <Section id="products"><HelpCards /></Section>
        <Section id="pricing"><Pricing /></Section>
        <Section id="appliances"><ApplianceBrands /></Section>
        <Section id="promises"><Promises /></Section>
        <Section id="quote"><QuoteLookup /></Section>
        <Section id="brands"><BrandStrip /></Section>
        <Section id="engineers"><EngineersSection /></Section>
        <Section id="repair"><RepairCare /></Section>
        <Section id="faq"><FAQSection /></Section>
        <Section id="blog"><BlogSection /></Section>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
